module.exports = __webpack_public_path__ + "static/fonts/uni.fd30455f.ttf";